//import example from './components/example';
import nav from './components/nav';
import microModal from './components/micro-modal';
import commentForm from './components/comment-form';
import copyToClipboard from './components/copy-to-clipboard';
import emailSignupForms from './components/email-signup';
import tableWrap from './components/table-wrap';
import scrollTo from './components/scroll-to';
import customSelect from './components/custom-select';
import backToTop from './components/back-to-top';
import lazyloadComments from './components/comment-lazyload';
import youtubeSchema from './components/youtube-schema';
import triggerEventTracking from './components/analytics/cta-events';
import triggerLinkTracking from './components/analytics/link';
import triggerProviderTracking from './components/analytics/providers';
import triggerTracking from './components/tracking';
import activateTextToSpeech from './components/text-to-speech';
import feedback from './components/feedback';
import medicareBanner from './components/medicare-banner';

console.log('Main JS loaded!');

//example();
nav();
microModal();
commentForm();
copyToClipboard();
emailSignupForms();
tableWrap();
scrollTo();
customSelect();
backToTop();
lazyloadComments();
youtubeSchema();
triggerEventTracking();
triggerLinkTracking();
triggerProviderTracking();
triggerTracking();
activateTextToSpeech();
feedback();
medicareBanner();
